import React, { useEffect, useState } from "react";
import { getSpecies, searchSpecies } from "../../api/species/speciesApi";
import {
  IUCNStatus,
  PopulationTrend,
  Species,
  SpeciesCategory,
} from "../common/ObjectTypes";
import { toast } from "react-toastify";
import SpeciesList from "./SpeciesList";
import { MoonLoader } from "react-spinners";
import { useNavigate } from "react-router-dom";
import { getPopulationTrends } from "../../api/populationtrend/populationtrendApi";
import { getSpeciesCategories } from "../../api/speciesCategory/speciesCategoryApi";
import { getIUCNStatus } from "../../api/iucnstatus/iucnstatusApi";

const ManageSpeciesController = () => {
  const [species, setSpecies] = useState<Species[]>([]);
  const [populationTrends, setPopulationTrends] = useState<PopulationTrend[]>(
    []
  );
  const [speciesCategories, setSpeciesCategories] = useState<SpeciesCategory[]>(
    []
  );
  const [iucnStatuses, setIucnStatuses] = useState<IUCNStatus[]>([]);
  const [pageLoaded, setPageLoaded] = useState(false);
  const [loading, setLoading] = useState(false);
  const [reloadPage, setReloadPage] = useState(true);
  // const [query, setQuery] = useState<string>("");
  const [pageCount, setPageCount] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [recordStart, setRecordStart] = useState(0);
  const [recordEnd, setRecordEnd] = useState(0);
  const pageSize = 25;
  const [searchQuery, setSearchQuery] = useState({
    name: "",
    pageNumber: 1,
    pageSize,
    // selectVideoCataloguesPage ? pageSize : 25,
  });
  const navigate = useNavigate();

  useEffect(() => {
    const loadSpecies = async () => {
      setLoading(true);
      try {
        const temp = await searchSpecies(searchQuery);
        setSpecies(temp.results);
        setPageCount(Math.ceil(temp.totalCount / pageSize));
        setTotalCount(temp.totalCount);
        const start = (searchQuery.pageNumber - 1) * searchQuery.pageSize + 1;
        const end = Math.min(start + temp.results.length - 1, temp.totalCount);

        setRecordStart(start);
        setRecordEnd(end);
        setPageLoaded(true);
        setReloadPage(false);
      } catch (err) {
        console.log(err);
      } finally {
        setLoading(false);
      }
    };

    const loadPopulationTrends = async () => {
      try {
        const temp = await getPopulationTrends();
        setPopulationTrends(temp);
      } catch (err) {
        console.log(err);
      }
    };

    const loadSpeciesCategories = async () => {
      try {
        const temp = await getSpeciesCategories();
        setSpeciesCategories(temp);
      } catch (err) {
        console.log(err);
      }
    };

    const loadIucnStatus = async () => {
      try {
        const temp = await getIUCNStatus();
        setIucnStatuses(temp);
      } catch (err) {
        console.log(err);
      }
    };

    loadSpecies();
    loadPopulationTrends();
    loadSpeciesCategories();
    loadIucnStatus();
  }, [pageLoaded, reloadPage]);

  const handleOnClickAdd = () => {
    navigate("/species/add");
  };

  const handlePageClick = (selectedItem: { selected: number }) => {
    setSearchQuery((prevQuery) => ({
      ...prevQuery,
      pageNumber: selectedItem.selected + 1,
    }));
    setReloadPage(true);
  };

  const handleSelectSpecies = (id: any) => {
    navigate(`/species/${id}/edit`);
  };

  const handleSearch = async (e: any) => {
    try {
      setReloadPage(true);
    } catch (error) {
      console.log(error);
    }
  };

  const handleChangeFilter = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery((prevQuery: any) => ({
      ...prevQuery,
      name: event.target.value,
    }));
  };

  const handleDelete = async () => {
    try {
      toast.success("Species was deleted.", {
        position: toast.POSITION.TOP_RIGHT,
        hideProgressBar: true,
        autoClose: 2500,
      });
      setPageLoaded(false);
    } catch (error) {
      console.log(error);
    }
  };

  return !pageLoaded ? (
    <div className="flex justify-center items-center">
      <MoonLoader color="#9EB45B" />
    </div>
  ) : (
    <SpeciesList
      species={species}
      populationTrends={populationTrends}
      speciesCategories={speciesCategories}
      iucnStatuses={iucnStatuses}
      // subStr={query}
      onSelectSpecies={handleSelectSpecies}
      onClickAdd={handleOnClickAdd}
      onDelete={handleDelete}
      onChangeSearch={handleChangeFilter}
      onSearch={handleSearch}
      searchQuery={searchQuery}
      pageCount={pageCount}
      pageSize={pageSize}
      totalCount={totalCount}
      handlePageClick={handlePageClick}
      reloadPage={reloadPage}
      recordStart={recordStart}
      recordEnd={recordEnd}
      loading={loading}
    />
  );
};

export default ManageSpeciesController;
